if (window.matchMedia('(max-width: 768px)').matches) {
    // add wrappers to tables in text
    [...document.querySelectorAll('.text table')].forEach((table) => {
        // create a wrapper div for table
        const tableWrapper = document.createElement('div');
        tableWrapper.classList.add('table-wrapper');

        // create a scroll wrapper div for table
        const tableScrollWrapper = document.createElement('div');
        tableScrollWrapper.classList.add('table-wrapper__scroll-wrapper');

        // move scroll wrapper to wrapper
        tableWrapper.appendChild(tableScrollWrapper);

        // add wrapper to DOM, before table
        table.parentNode.insertBefore(tableWrapper, table);

        // move table to wrapper
        tableScrollWrapper.appendChild(table);

        // set min width of table to text width
        table.style.minWidth = '720px'; // eslint-disable-line no-param-reassign
    });
}

// advanced table
const tsubtitles = document.querySelectorAll('.block--advanced-table .tsubtitle--bg');
tsubtitles.forEach((subtitle) => {
    const cell = subtitle.parentNode;
    if (cell.nodeName === 'TD' || cell.nodeName === 'td' ||
        cell.nodeName === 'TH' || cell.nodeName === 'th') {
        cell.classList.add('has-bg');
    }
});

const tfoots = document.querySelectorAll('.block--advanced-table .tfoot');
tfoots.forEach((cell) => {
    const row = cell.parentNode.parentNode;
    if (row.nodeName === 'TR' || row.nodeName === 'tr') {
        row.classList.add('is-foot');
    }
});
